import { useQuery } from "@tanstack/react-query";
import { getAllWellnessLectureByYogaCenterIdAndMemberIdAndStartDateTimeBetweenAndIsDeleteFalse } from "../../../service";
import { Dayjs } from "dayjs";
import { getProgramListWeb } from "../../../service/program";

const yogaCenterRadioOptionList = [
    { id: 0, label: "전체" },
    { id: 3, label: "선릉" },
    { id: 2, label: "도산" },
];

const useGetAllWellnessLectureByYogaCenterIdAndMemberIdAndStartDateTimeBetweenAndIsDeleteFalse = (yogaCenterId: number, startDate: Dayjs, endDate: Dayjs) => {
    const query = useQuery({
        queryKey: ['wellnessLectures', yogaCenterId, startDate, endDate],
        queryFn: () => getAllWellnessLectureByYogaCenterIdAndMemberIdAndStartDateTimeBetweenAndIsDeleteFalse(
            yogaCenterId,
            startDate.startOf('d').toISOString(),
            endDate.endOf('d').toISOString()
        ),
        select: (res) => res.data?.filter(q => !q.isShowMembershipOnly),
        enabled: !!startDate && !!endDate,
    });

    return query
}


const useGetProgramListWeb = (responseQuery?: string) => {
    const query = useQuery({
        queryKey: ['getProgramListWeb', responseQuery],
        queryFn: () => getProgramListWeb(responseQuery),
        select: res => res.data.data.getProgramListWeb?.sort((a, b) => b.displayIdx - a.displayIdx)
    });
    return query;
}


export { yogaCenterRadioOptionList, useGetAllWellnessLectureByYogaCenterIdAndMemberIdAndStartDateTimeBetweenAndIsDeleteFalse, useGetProgramListWeb }